module.exports = __webpack_public_path__ + "img/02_tone_1200.4971be61.png";